import { AdminPageHeader } from '@/components/patterns/admin-page'
import LocationForm from '@/components/forms/LocationForm'
import { LocationFulfillmentSetupActions } from '@/components/locations/LocationFulfillmentSetupActions'
import { LocationSettingsActionGroup } from '@/components/locations/LocationSettingsActionGroup'

import { locationFilters, useLocation } from '@/lib/services/locations/locations.query'
import { getLocationName } from '@/lib/services/locations/locations.utils'
import { createFileRoute } from '@tanstack/react-router'
import { MapPin } from 'lucide-react'

const filters = locationFilters().get()

export const Route = createFileRoute('/_authenticated/$orgId/settings/locations/$locationId/')({
  component: RouteComponent,
  loader: ({ context }) => {
    return { isReadOnly: !context.ability.can('edit', 'locations') }
  },
})

function RouteComponent() {
  const { locationId } = Route.useParams()

  const { data: location } = useLocation(locationId, { filters })

  return (
    <div className="space-y-4">
      <AdminPageHeader
        className="@container/location-settings-header"
        innerClassName="sm:flex-wrap @[64rem]/location-settings-header:flex-nowrap"
        actionsClassName="w-full @[64rem]/location-settings-header:w-auto"
        icon={MapPin}
        title={getLocationName(location)}
        description="Manage address, contact details, and online ordering setup for this location."
        actions={
          <LocationSettingsActionGroup
            location={location}
            locationId={locationId}
            className="w-full justify-start @[64rem]/location-settings-header:w-auto @[64rem]/location-settings-header:justify-end"
          />
        }
      />
      <LocationFulfillmentSetupActions location={location} locationId={locationId} />
      <LocationForm initialData={location} />
    </div>
  )
}
